import { SKINS } from '../themes/skins';
import { MONETIZATION } from './config';
import { grantRemoveAds, grantSkin } from './entitlements';
import { StoreProduct } from './iap';

export type ProductGrant = 'remove-ads' | 'skin' | 'all-skins';

export interface CatalogProduct extends StoreProduct {
  grants: ProductGrant;
  skinId?: string;
}

export function skinProductId(skinId: string): string {
  return `${MONETIZATION.ids.skinProductPrefix}${skinId}`;
}

export function buildCatalog(): CatalogProduct[] {
  const products: CatalogProduct[] = [
    {
      id: MONETIZATION.ids.removeAdsProduct,
      title: 'Remove ads',
      description: 'no banners, no interstitials - just the clock',
      priceLabel: '$1.99',
      kind: 'non-consumable',
      grants: 'remove-ads',
    },
  ];

  for (const skin of SKINS) {
    if (skin.price <= 0) {
      continue;
    }
    products.push({
      id: skinProductId(skin.id),
      title: skin.name,
      description: skin.tagline,
      priceLabel: `$${(skin.price / 100).toFixed(2)}`,
      kind: 'non-consumable',
      grants: 'skin',
      skinId: skin.id,
    });
  }

  products.push({
    id: 'skin_bundle',
    title: 'Every skin',
    description: 'all skins, forever',
    priceLabel: '$4.99',
    kind: 'non-consumable',
    grants: 'all-skins',
  });

  return products;
}

export function applyProductGrants(productIds: string[]): void {
  const catalog = buildCatalog();
  for (const productId of productIds) {
    const product = catalog.find((entry) => entry.id === productId);
    if (!product) {
      continue;
    }
    if (product.grants === 'remove-ads') {
      grantRemoveAds();
    } else if (product.grants === 'skin' && product.skinId) {
      grantSkin(product.skinId);
    } else if (product.grants === 'all-skins') {
      for (const skin of SKINS) {
        grantSkin(skin.id);
      }
    }
  }
}
